import { render, staticRenderFns } from "./RequestReturnCreation.vue?vue&type=template&id=b06fbcae&scoped=true"
import script from "./RequestReturnCreation.vue?vue&type=script&lang=js"
export * from "./RequestReturnCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06fbcae",
  null
  
)

export default component.exports